module.exports = __webpack_public_path__ + "static/media/pontdugard_tn.748a9f52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/pontdugard_tn.jpg
// module id = 750
// module chunks = 0